import { MileageSummary, TripForMileage } from "./types";

export function getTripMileageSummary(trip: TripForMileage): MileageSummary {
  const plannedEmptyMiles =
    (trip.distanceToStart ?? 0) + (trip.distanceToEnd ?? 0);

  return {
    routeMiles: trip.routeDistance ?? null,
    loadedMiles: trip.loadedDistance ?? trip.predictedLoadedDistance ?? null,
    emptyMiles: trip.deadheadDistance ?? plannedEmptyMiles,
    actualMiles: trip.totalDistance ?? null,
  };
}
